<!-- @format -->

<invoice-tag>
  <div class="contents contents-wide">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_delivery">納品一覧</h1>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/croco-desk/" class="home">ホーム</a>
          </li>
          <li class="breadcrumb-item">納品一覧</li>
        </ul>
      </div>
      <!--/.container_heading-->

      <div class="table-nav_area">
        <div class="search-conditions_area">
          <p class="search-conditions-heading">現在の検索条件：</p>
          <ul class="search-conditions-list">
            <li
              class="search-conditions-list-item"
              each="{ tag in state.tags }"
            >
              <span
                class="label label-search-conditions js-label-close"
                onclick="{ e => onTag(tag.name) }"
              >
                { tag.label } : { tag.value }
              </span>
            </li>
          </ul>
        </div>
        <!--/.search-conditions_area-->
        <button
          class="button button-modal button-modal-search js-modal-open"
          type="button"
          value="検索条件設定"
          onclick="{ e => update({ searchModalIsOpen: true }) }"
        >
          検索条件設定
        </button>
      </div>
      <!--/.table-nav_area-->

      <div class="table-nav_area">
        <p class="search_number" if="{ state.pager.total > 0}">
          全{ state.pager.total }件中 { state.params.limit*(state.pager.page-1)
          + 1 }〜{ state.params.limit*(state.pager.page-1) +
          state.pager.items.length }件
        </p>
        <p class="search_number" if="{ state.pager.total == 0}">
          条件をを満たす注文は見つかりませんでした。
        </p>
        <div class="sort-menu">
          <label for="sort" class="sort-menu-title">表示件数</label>
          <select
            name="sort"
            id="sort"
            class="sort-list"
            onchange="{ setLimit }"
          >
            <option each="{ limit in Limits }" value="{ limit }">
              { limit }件
            </option>
          </select>
        </div>
        <!--/.sort-menu-->
      </div>
      <!--/.table-nav_area-->

      <div
        class="contents_block table"
        is="delivery-list"
        list="{ state.pager.items }"
        order-name="{ state.orderName }"
        order-by="{ state.params.orderby }"
        set-order-by="{ setOrderBy }"
      ></div>

      <div class="pagination" if="{ state.pager.items.length > 0 }">
        <ul>
          <li><a class="first" onclick="{ e => onPager(1) }"></a></li>
          <li>
            <a
              class="prev"
              onclick="{ e => onPager(state.pager.page > 1 ? state.pager.page -1 : 1) }"
            ></a>
          </li>
          <li>
            <a
              each="{ page in Array(Number(state.pager.last)).fill(0).map((c,i) => i+1) }"
              class="{ state.pager.page == page ? 'is-active' : '' }"
              onclick="{ e => onPager(page) }"
            >
              { page }
            </a>
          </li>
          <li>
            <a
              class="next"
              onclick="{ e => onPager(state.pager.page < state.pager.last ? state.pager.page + 1 : state.pager.last) }"
            ></a>
          </li>
          <li>
            <a class="last" onclick="{ e => onPager(state.pager.last) }"></a>
          </li>
        </ul>
      </div>
      <!--/.pagination-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <delivery-search-modal
    params="{ state.params }"
    is-open="{ state.searchModalIsOpen }"
    on-close="{ e => update({searchModalIsOpen: false}) }"
    on-search="{ onSearch }"
  ></delivery-search-modal>

  <script>
    import di from "dependency-injection";
    import list from "@tags/parts/croco-desk/delivery-list.riot";
    import modal from "@tags/modal/croco-desk/delivery-search-modal.riot";

    export default {
      components: {
        "delivery-list": list,
        "delivery-search-modal": modal,
      },
      CrocoDeskApi: false,
      Limits: [10, 20, 50, 100],
      state: {
        searchModalIsOpen: false,
        pager: { last: 0, next: 0, page: 1, prev: 1, total: 0, items: [] },
        orderName:'id',
        params: {
          orderby: "asc",
          limit: 10,
        },
        tags: {},
      },
      onBeforeMount() {
        this.CrocoDeskApi = di.createApi();
      },
      onMounted() {
        this.onPager({}, 1);
      },
      async onPager(page) {
        this.state.params.page = page;
        const res = await this.CrocoDeskApi.request(
          "delivery",
          "fetch",
          this.state.params
        );
        this.update({ pager: res });
      },
      setLimit(e) {
        this.state.params.limit = e.target.value;
        this.onPager(1);
      },
      setOrderBy(direction, name) {
        this.state.orderName = name
        this.state.params.orderby = direction;
        this.onPager(1);
      },
      onTag(name) {
        delete this.state.params[name];
        this.update({
          params: this.state.params,
          tags: this.state.tags.filter((e) => e.name != name),
        });
        this.onPager(1);
      },
      onSearch(params, tags) {
        params.limit = this.state.params.limit;
        params.orderby = this.state.params.orderby;
        this.update({ params, tags, searchModalIsOpen: false });
        this.onPager(1);
      },
    };
  </script>
</invoice-tag>
